import { createFileRoute } from '@tanstack/react-router';
import { SidebarLayout } from '@trukt/ui/SidebarLayout';
import { SidebarContainer } from '@components/pages/components';

export const Route = createFileRoute('/_order')({
  component: OrderLayout,
});

function OrderLayout() {
  return <SidebarLayout sidebar={<SidebarContainer />} />;
}
